// export enum ELangTransform {
//   /** 简体中文 */
//   'zh' = 'CMN',
//   /** 英语 */
//   'en' = 'ENG',
//   /** 越南语 */
//   'vie' = 'VIE',
//   /** 繁体中文 */
//   'cht' = 'ZHO',
//   /** 日语 */
//   'jp' = 'JPN',
//   /** 泰语 */
//   'th' = 'THA',
//   /** 韩语 */
//   'kor' = 'KOR',
//   /** 阿拉伯语 */
//   'ara' = 'SAU',
//   /** 德语 */
//   'de' = 'DEU',
//   /** 西班牙语 */
//   'spa' = 'SPA',
//   /** 法语 */
//   'fra' = 'FRA',
//   /** 巴西葡萄牙语 */
//   'pot' = 'BRA',
//   /** 俄语 */
//   'ru' = 'RUS',
//   /** 印地语 */
//   'hi' = 'HIN',
//   /** 马来语 */
//   'may' = 'MSA',
//   /** 印尼语 */
//   'id' = 'IND',
//   /** 土耳其语 */
//   'tr' = 'TR',
// }

export enum ELangTransform {
  /** 简体中文 */
  'zh-CN' = 'CMN',
  /** 英语 */
  'en' = 'ENG',
  /** 越南语 */
  'vn' = 'VIE',
  /** 中文（繁体） */
  'zho' = 'ZHO',
  /** 日语 */
  'ja' = 'JPN',
  /** 泰语 */
  'tha' = 'THA',
  /** 韩语 */
  'kor' = 'KOR',
  /** 阿拉伯语 */
  'sa' = 'SAU',
  /** 德语 */
  'de' = 'DEU',
  /** 西班牙语 */
  'es' = 'SPA',
  /** 法语 */
  'fr' = 'FRA',
  /** 葡萄牙语 */
  'br' = 'BRA',
  /** 俄语 */
  'ru' = 'RUS',
  /** 印地语 */
  'hi' = 'HIN',
  /** 马来语 */
  'ms' = 'MSA',
  /** 印度尼西亚语 */
  'in' = 'IND',
  /** 土耳其语 */
  'trk' = 'TR',
}
